<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div class="p-20 text-center">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <img src="assets/warning-icon.svg" alt="sent">
        <h3 class="bold header_title dark-blue">Utilisateur activé</h3>
      </div>

      <div class="p-20">
        <p class="no-margin mb-10 text-center light-blue">{{contactEnabled}}</p>
      </div>


      <div class="p-20 margin-center">
        <v8te-active-button [buttonText]="'Ok'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
          [border]="'solid 1px #D9D9D9'" [active]="true" (click)="onDismiss(true)" [height]="50" [minWidth]="190"
          [widthPercent]="50" [bold]="true"></v8te-active-button>
      </div>
    </div>
  </div>
</div>